console.log('js/adyen.js -> v0.1.0');

function encryptForm(form, key) {
	if (typeof adyen.encrypt.createEncryptedForm === "function") {
		(function() {
			adyen.createEncryptedForm = function(form, options) {
				return adyen.encrypt.createEncryptedForm(form, key, options);
			};
			if (typeof adyen.encrypt.createEncryption === "function") {
				adyen.createEncryption = function(options) {
						return adyen.encrypt.createEncryption(key, options);
				};
			}
		}());
	} else {
		adyen.cse.available = false;
	}

	var options = {
		enableValidations: false, // when enabled the form doesn't submit with errors
		submitButtonAlwaysEnabled: true,
		numberIgnoreNonNumeric: true,
		cardTypeElement: function(cardType, cardName) {
			if( cardType != 'unknown' ){
				$('#card-type').css('background-image', 'url(https://live.adyen.com/hpp/img/pm/'+cardType+'_tiny.png)')
			}
			$('#card-type-input', form).val(cardType);
		},
		onsubmit: function(event) {
			gae('payment-form', 'submitted');
			const button = document.querySelector('.js-payment-submit-trigger');
			button.disabled = true;
			button.classList.add('is-loading');

			// Save CC data on client side storage
			saveEnteredData();
		},
	};

	// Load CC data from client side storage
	loadEnteredData();

	var ef = adyen.createEncryptedForm(form, options);

	if (ef) {
		ef.addCardTypeDetection(options.cardTypeElement);
		ef.addValidations(); // We want the form to submit with errors but still want client side validations

		// Somehow handleSubmit is not being called automatically
		// on submit.
		// I don't understand why, already begged and cried and it
		// still doesn't work. I'm binding it here by hand myself.
		$(form).on('submit', ef.handleSubmit.bind(ef));
		// how to read: auto cardData = ctx.req.form.get("adyen-encrypted-data", "");
	}
}

function saveEnteredData() {
	sessionStorage.setItem("paymentMethod", $('input[name=brandCode]:checked').attr('id'));
	sessionStorage.setItem("cc", $("#adyen-encrypted-form-number").val());
	sessionStorage.setItem("month", $("#adyen-encrypted-form-expiry-month").val());
	sessionStorage.setItem("year", $("#adyen-encrypted-form-expiry-year").val());
}

function loadEnteredData(){
	loadFieldFromSession("cc", "#adyen-encrypted-form-number");
	loadFieldFromSession("month","#adyen-encrypted-form-expiry-month");
	loadFieldFromSession("year","#adyen-encrypted-form-expiry-year");
}

function loadFieldFromSession(id, field){
	if(sessionStorage != null)	{
		var elem = sessionStorage.getItem(id);
		if (elem != 'undefined' && elem != null && elem != "")
			$(field).val(elem);
	}
}
